<template>
    <Loader :isActive="!loadding" />

    <div
        class="config-form-content weeduc-admin-config adminWeeducConfig"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div
            class="row g-3 g-lg-4 weeduc-admin-config-layout mx-0"
            v-if="!loadding"
        >
            <div class="col-12 col-lg-6 weeduc-admin-config-col">
                <div class="weeduc-admin-config-section">
                    <h3 class="weeduc-admin-config-section-title">
                        SEO e visibilidade
                    </h3>
                    <p class="weeduc-admin-config-section-lead">
                        Informações usadas por buscadores e para controlar se o site fica
                        público.
                    </p>

                    <div class="form-group">
                        <label
                            class="form-label"
                            for="adminWeeducConfigTitleInput"
                        >
                            Título
                        </label>
                        <input
                            type="text"
                            class="form-input"
                            placeholder="Ex.: Videoteca ALLTech"
                            v-model="title"
                            id="adminWeeducConfigTitleInput"
                            required
                        />
                        <small class="form-small-description">
                            Título do seu site utilizado para mecanismos de pesquisa (SEO).
                        </small>
                    </div>

                    <div class="form-group">
                        <label
                            class="form-label"
                            for="adminWeeducConfigDescriptionInput"
                        >
                            Descrição
                        </label>
                        <textarea
                            class="form-input"
                            v-model="description"
                            id="adminWeeducConfigDescriptionInput"
                        ></textarea>
                        <small class="form-small-description">
                            Descrição do seu site utilizada para mecanismos de pesquisa (SEO).
                        </small>
                    </div>

                    <div class="form-group weeduc-admin-config-field-status">
                        <v-select
                            v-model="status"
                            :items="statusFilterOptions"
                            item-title="text"
                            item-value="value"
                            label="Status do site"
                            variant="outlined"
                            class="filter-form-control inputd weeduc-admin-v-field"
                            :menu-props="adminSelectMenuProps"
                            density="compact"
                            hide-details
                            @update:modelValue="filtrarPorStatus"
                        />
                        <small class="form-small-description">
                            Selecione o status de visibilidade do site.
                        </small>
                    </div>

                    <div class="form-group">
                        <label
                            class="form-label"
                            for="adminWeeducConfigKeyWordsInput"
                        >
                            Palavras-chave
                        </label>
                        <textarea
                            class="form-input"
                            v-model="keyWords"
                            id="adminWeeducConfigKeyWordsInput"
                        ></textarea>
                        <small class="form-small-description">
                            Palavras-chave do seu site utilizadas para mecanismos de pesquisa
                            (SEO).
                        </small>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6 weeduc-admin-config-col">
                <div class="weeduc-admin-config-section">
                    <h3 class="weeduc-admin-config-section-title">
                        Identidade e contato
                    </h3>
                    <p class="weeduc-admin-config-section-lead">
                        Logo, favicon e WhatsApp exibidos no site e no portal.
                    </p>

                    <div class="form-group">
                        <label class="form-label">Logo</label>
                        <span class="weeduc-admin-config-hint"
                            >Altura máxima recomendada: 80px</span
                        >
                        <div class="form-file weeduc-admin-file-zone">
                            <div class="file-wrapper primary weeduc-admin-file-wrapper">
                            <img
                                :src="logoPreview ? logoPreview : logo"
                                alt="Logo"
                                v-show="logoPreview || logo"
                                class="image-preview weeduc-admin-logo-preview"
                            />
                            <span class="thumbnail" v-if="!logoPreview && !logo">
                                <span class="icon">
                                    <svg
                                        width="46"
                                        height="39"
                                        viewBox="0 0 46 39"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                            stroke="#9D9FA3"
                                            stroke-width="1.25714"
                                        ></path>
                                        <rect
                                            x="1.00049"
                                            y="1.40454"
                                            width="43.9461"
                                            height="36.1909"
                                            rx="2.58507"
                                            stroke="#9D9FA3"
                                            stroke-width="1.25714"
                                        ></rect>
                                        <circle
                                            cx="14.8948"
                                            cy="10.6676"
                                            r="3.71629"
                                            stroke="#9D9FA3"
                                            stroke-width="1.25714"
                                        ></circle>
                                    </svg>
                                </span>
                                <span class="text">
                                    Clique aqui para selecionar a imagem
                                </span>
                            </span>
                            <input
                                class="form-control weeduc-admin-file-input"
                                type="file"
                                @change="updateFilePathLogo"
                                accept=".png, .jpg, .jpeg, .webp"
                            />
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="form-label" for="adminWeeducFaviconInput"
                            >Favicon</label
                        >
                        <div class="form-file weeduc-admin-file-zone weeduc-admin-file-zone--compact">
                            <div class="file-wrapper primary weeduc-admin-file-wrapper">
                            <img
                                :src="faviconPreview ? faviconPreview : favicon"
                                alt="Favicon"
                                v-show="faviconPreview || favicon"
                                class="image-preview weeduc-admin-favicon-preview"
                            />
                            <span class="thumbnail" v-if="!faviconPreview && !favicon">
                                <span class="icon">
                                    <svg
                                        width="46"
                                        height="39"
                                        viewBox="0 0 46 39"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                            stroke="#9D9FA3"
                                            stroke-width="1.25714"
                                        ></path>
                                        <rect
                                            x="1.00049"
                                            y="1.40454"
                                            width="43.9461"
                                            height="36.1909"
                                            rx="2.58507"
                                            stroke="#9D9FA3"
                                            stroke-width="1.25714"
                                        ></rect>
                                        <circle
                                            cx="14.8948"
                                            cy="10.6676"
                                            r="3.71629"
                                            stroke="#9D9FA3"
                                            stroke-width="1.25714"
                                        ></circle>
                                    </svg>
                                </span>
                                <span class="text">
                                    Clique aqui para selecionar a imagem
                                </span>
                            </span>
                            <input
                                id="adminWeeducFaviconInput"
                                class="form-control weeduc-admin-file-input"
                                type="file"
                                @change="updateFilePathIcon"
                                accept=".ico, .png, .jpg, .jpeg, .webp"
                            />
                        </div>
                        </div>
                    <small class="form-small-description">
                        Formato recomendado: .ico ou .png (quadrado, 32×32px ou maior).
                    </small>
                    </div>

                    <div class="form-group">
                        <label
                            class="form-label"
                            for="adminWeeducConfigPhoneInput"
                        >
                            WhatsApp / telefone
                        </label>
                        <input
                            type="text"
                            class="form-input"
                            placeholder="(21) 99999-9999"
                            v-model="numberPhone"
                            id="adminWeeducConfigPhoneInput"
                            required
                            @input="onPhoneInput"
                            maxlength="15"
                            autocomplete="tel"
                        />
                        <small class="form-small-description">
                            Número exibido no site e usado para contato (WhatsApp).
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <div class="buttons-container weeduc-admin-site-form-actions" v-if="!loadding">
            <div class="button" v-show="hasSite">
                <button
                    type="button"
                    @click="save()"
                    class="btn btn-block btn-content"
                >
                    Salvar Edição e Publicar
                </button>
                <button type="button" @click="clearCache()" class="btn btn-block btn-content">
                    Limpar Cache
                </button>
            </div>
            <div class="button" v-show="!hasSite">
                <button
                    type="button"
                    @click="save()"
                    class="btn btn-block btn-content"
                >
                    Criar e Publicar
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/utils/site';
    import apiSiteBasic from '@/utils/Site/basic';
    import apiWebsite from '@/utils/Weflix/content'
    import apiAWS from '@/utils/storage/aws';
    import { mapState } from 'vuex';
    import Loader from '@/components/Loader/loader.vue';
    import { toast } from 'vue3-toastify';
    

    export default {
        data() {
            return {
                hasSite: false,
                title: '',
                url: '',
                logo: null,
                logoPreview: null,
                favicon: null,
                faviconPreview: null,
                description: '',
                keyWords: '',
                status: '',
                id: null,
                hasReady: true,
                windowWidth: window.innerWidth,
                loadding: false,
                statusFilter: '',
                dataWebsite: null,
                numberPhone: '',
                statusFilterOptions: [
                    { text: 'Ativo', value: 1 },
                    { text: 'Inativo', value: 0 }
                ]
            };
        },
        components: {
            Loader,
        },
        computed: {
            ...mapState(['token', 'dark']),

            adminSelectMenuProps() {
                return this.dark
                    ? { contentClass: 'weeduc-admin-select-menu-dark' }
                    : {};
            },
        },
        methods: {
            async putFileAws(url, file) {
                try {
                    await apiAWS.putFileAWS(url, file);
                } catch (error) {
                    console.error('Erro ao enviar arquivo para AWS');
                }
            },
            async updateFilePathLogo(event) {
                const file = event.target.files[0];
                if (!file) return;
                this.logoPreview = URL.createObjectURL(file);

                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    await this.putFileAws(response.url, file);
                    this.logo = response.token;
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async updateFilePathIcon(event) {
                const file = event.target.files[0];
                if (!file) return;
                this.faviconPreview = URL.createObjectURL(file);

                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    await this.putFileAws(response.url, file);
                    this.favicon = response.token;
                    console.debug(response);
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async getConfigSite() {
                this.loadding = true;
                try {
                    const response = await apiSiteBasic.getBasicData(
                        this.token
                    );

                    this.hasSite = true;
                    this.title = response.title;
                    this.url = response.url;
                    this.description = response.description;
                    this.keyWords = response.keywords;
                    // Ajuste: garantir que status seja sempre inteiro (1 ou 0)
                    this.status = typeof response.status === 'string' ? parseInt(response.status) : response.status;
                    this.logo = response.logo;
                    this.favicon = response.favicon;
                    this.logoPreview = response.logoFinal;
                    this.faviconPreview = response.faviconFinal;
                    this.loadding = false;
                } catch (error) {
                    toast.error('Erro ao carregar as configurações do Site');
                    console.error(
                        'Erro ao carregar as configurações do Site',
                        error
                    );
                    this.loadding = false;
                }
            },
            async createSite() {
                const obj = {
                    nome: this.title,
                    title: this.title,
                    description: this.description,
                    keywords: this.keyWords,
                    logo: this.logo,
                    favicon: this.favicon,
                    status: typeof this.status === 'string' ? parseInt(this.status) : this.status,
                };
                try {
                    await api.CreateSite(this.token, obj);
                    toast.success('Site criado com sucesso');
                } catch (error) {
                    toast.error('Erro ao criar o Site');
                    console.error('Erro ao criar Site', error);
                }
            },
            async editSite() {
                const obj = {
                    nome: this.title,
                    title: this.title,
                    description: this.description,
                    keywords: this.keyWords,
                    logo: this.logo,
                    favicon: this.favicon,
                    status: typeof this.status === 'string' ? parseInt(this.status) : this.status,
                };
                try {
                    await apiSiteBasic.putBasicData(
                        this.token,
                        obj
                    );
                    if(this.numberPhone){
                        await this.editWebsite();
                    }
                    await this.getConfigSite();
                    toast.success('Configurações do site atualizadas com sucesso!');
                } catch (error) {
                    console.error('Erro ao editar Site', error);
                    toast.error('Erro ao editar o Site');
                }
            },
            async clearCache() {
                try {
                    this.loadding = true;
                    await api.clearCache(this.token);
                    toast.success('Cache limpo com sucesso!');
                } catch (error) {
                    toast.error('Erro ao limpar cache.');
                } finally {
                    this.loadding = false;
                }
            },
            save() {
                if (this.hasSite) {
                    this.editSite();
                } else {
                    this.createSite();
                }
            },
            filtrarPorStatus(valor) {
                // Ajuste: garantir que status seja inteiro
                this.status = typeof valor === 'string' ? parseInt(valor) : valor;
            },
            async getDataWebsite() {
                try {
                    const response = await apiWebsite.getWebsite(this.token)
                    console.log(response)
                    this.dataWebsite = response
                    if (response) {
                        // Chama a máscara ao pegar os dados da API
                        this.numberPhone = this.applyPhoneMask(response.phone);
                    }
                } catch (error) {
                    toast.error('Erro ao buscar dados do site')
                    console.error('Erro ao buscar dados do site:', error)
                }
            },
            async editWebsite() {
            
                try {
                    const payload = {
                    ...this.dataWebsite,
                    phone: this.numberPhone,
                    logo: this.logo,
                    favicon: this.favicon,
                    }
                    const response = await apiWebsite.updateWebsite(
                    this.token,
                    this.dataWebsite.id,
                    payload
                    )
                    console.debug(response)
                } catch (error) {
                    console.error('Erro ao atualizar o portalBannerPath:', error)
                } 
            },
            onPhoneInput(event) {
                let value = event.target.value.replace(/\D/g, '');

                if (value.length > 11) value = value.slice(0, 11);

                if (value.length > 0) {
                    if (value.length <= 2) {
                        value = `(${value}`;
                    } else if (value.length <= 6) {
                        value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
                    } else if (value.length <= 10) {
                        value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`;
                    } else {
                        value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;
                    }
                }

                this.numberPhone = value;
            },
            applyPhoneMask(phone) {
                if (!phone) return '';
                let value = phone.replace(/\D/g, '');

                if (value.length > 11) value = value.slice(0, 11);

                if (value.length > 0) {
                    if (value.length <= 2) {
                        value = `(${value}`;
                    } else if (value.length <= 6) {
                        value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
                    } else if (value.length <= 10) {
                        value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`;
                    } else {
                        value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;
                    }
                }

                return value;
            },
        },
        props: {
            saved: Boolean,
        },
        created() {
            this.getConfigSite();
            this.getDataWebsite();
        },
    };
</script>

<style>
    @import '@/css/weeduc/admin/config.css';
    textarea#adminWeeducConfigDescriptionInput {
        min-height: 200px;
    }
    textarea#adminWeeducConfigKeyWordsInput {
        min-height: 100px;
    }
</style>
